import { batchExecutionDetailsModalReducerKey } from './BatchExecutionDetailsModalConstants';

export const batchExecutionDetailsModal = (state) => state.get(batchExecutionDetailsModalReducerKey);

export const isLoading = (state) => batchExecutionDetailsModal(state).get('isLoading');

export const queries = (state) => batchExecutionDetailsModal(state).get('queries');

export const filename = (state) => batchExecutionDetailsModal(state).get('filename');

export const context = (state) => batchExecutionDetailsModal(state).get('context');

export const options = (state) => batchExecutionDetailsModal(state).get('options');

export const detailsList = (state) => batchExecutionDetailsModal(state).get('detailsList');

export const isShowPictures = (state) => batchExecutionDetailsModal(state).get('isShowPictures');
